import { AUTH_USER } from '../_actions/userActionTypes';

function userRuducer(state = {}, action) {
  switch (action.type) {
    case AUTH_USER:
      return { ...state, userData: action.payload };
    default:
      return state;
  }
}

export default userRuducer;
